// extracted by mini-css-extract-plugin
module.exports = {"actionGroup":"SpecialActions_actionGroup__1KdLR","shrinkButton":"SpecialActions_shrinkButton__1zI_S"};